<template>
  <div class="home">
    <TopBar v-show="isAdmin"/>
    <div class="p-2 sm:px-8">
      <NotificationBar></NotificationBar>
      <div class="row">
        <div class="col-sm-12 col-lg-4 d-flex" v-if="showLeads()">
          <LeadCard/>
        </div>
        <!-- Scheduled Posts Card -->
        <div class="col-sm col-lg-4 d-flex">
          <ScheduledPostsCard/>
        </div>
        <div class="col-sm-12 col-lg-4 d-flex">
          <IntegrationsCard/>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12" v-if="showListings()">
          <ListingTableCard class="mt-4"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import ListingTableCard from '../../components/ListingTableCard';
  import LeadCard from '../../components/LeadCard'
  import NotificationBar from '../../components/NotificationBanner';
  import TopBar from './DashboardTopBar';
  import ScheduledPostsCard from '../../components/SchedulePostsCard';
  import IntegrationsCard from "../../components/IntegrationsCard";

  import {getCookie} from "../../cookie";
  import {mapGetters, mapActions} from 'vuex';

  export default {
    name: "Home",
    data() {
      return {}
    },
    methods: {
      ...mapActions(['fetchMe']),

      showListings() {
        if (this.me.isImpersonated) {
          return this.me.impersonated.loggedInAs === 'realtor'
        }
        return this.me.tokenUser.loggedInAs === 'realtor'
      },
      showLeads() {
        if (this.me.isImpersonated) {
          return this.me.impersonated.loggedInAs === 'realtor' && this.me.impersonated.id === this.me.tokenUser.id
        }

        return this.me.tokenUser.loggedInAs === 'realtor'
      }
    },
    computed: {
      ...mapGetters(['me']),
      isAdmin() {
        return getCookie('admin');
      },
    },
    components: {
      IntegrationsCard,
      // TourStatsCard,
      ListingTableCard,
      LeadCard,
      NotificationBar,
      ScheduledPostsCard,
      TopBar
    },


  };
</script>

<style lang="scss">


</style>
